// CashbooksPage — 出納帳 統合ページ (2026-07-22)
//   西武信金出納帳 / 小口現金出納帳 / 室長立替金出納帳 をサイドナビ1項目に集約。
//   sub-tab は hash (#cashbooks/seibu|petty|chief) と同期し deep link 可。
//   legacy hash (#seibu_ledger / #petty_cash) は App.tsx 側で本ページへ誘導される。

import React, { useEffect, useState } from 'react';
import { SeibuCashLedgerPage } from './SeibuCashLedgerPage';
import { PettyCashPage } from './PettyCashPage';
import { HqCashLedgerPage } from './HqCashLedgerPage';

type SubKey = 'seibu' | 'petty' | 'chief' | 'ryogae' | 'honbu';

function readSubFromHash(): SubKey {
  if (typeof window === 'undefined') return 'seibu';
  const h = window.location.hash.toLowerCase();
  if (/^#?cashbooks\/petty(\/|$)/.test(h)) return 'petty';
  if (/^#?cashbooks\/chief(\/|$)/.test(h)) return 'chief';
  if (/^#?cashbooks\/ryogae(\/|$)/.test(h)) return 'ryogae';
  if (/^#?cashbooks\/honbu(\/|$)/.test(h)) return 'honbu';
  if (/^#?petty_cash(\/|$)/.test(h)) return 'petty';   // legacy deep link
  if (/^#?seibu_ledger(\/|$)/.test(h)) return 'seibu'; // legacy deep link
  return 'seibu';
}

const SUBS: Array<{ key: SubKey; label: string }> = [
  { key: 'seibu', label: '西武信金出納帳' },
  { key: 'petty', label: '小口現金出納帳' },
  { key: 'chief', label: '室長立替金出納帳' },
  { key: 'ryogae', label: '本部両替金出納帳' },
  { key: 'honbu', label: '本部現金出納帳' },
];

export const CashbooksPage: React.FC = () => {
  const [sub, setSub] = useState<SubKey>(readSubFromHash());

  useEffect(() => {
    const onHash = () => setSub(readSubFromHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const switchTo = (k: SubKey) => {
    setSub(k);
    window.location.hash = `#cashbooks/${k}`;
  };

  return (
    <div>
      <div className="pa-no-print" style={{
        display: 'flex', gap: 6, padding: '12px 24px 0',
        background: 'linear-gradient(180deg, #f8f7f5 0%, #f5f3f0 100%)',
      }}>
        {SUBS.map((s) => (
          <button key={s.key} type="button" onClick={() => switchTo(s.key)} style={{
            cursor: 'pointer', padding: '9px 20px', borderRadius: '10px 10px 0 0', fontSize: '0.8125rem', fontWeight: 800,
            border: `1px solid ${sub === s.key ? '#ddd9d3' : 'transparent'}`, borderBottom: 'none',
            background: sub === s.key ? '#fff' : 'rgba(255,255,255,0.45)', color: sub === s.key ? '#2f5fd0' : '#736d65',
          }}>{s.label}</button>
        ))}
      </div>
      {sub === 'seibu' && <SeibuCashLedgerPage />}
      {sub === 'petty' && <PettyCashPage book="petty_cash" />}
      {sub === 'chief' && <PettyCashPage book="chief_advance" />}
      {sub === 'ryogae' && <HqCashLedgerPage book="ryogae" />}
      {sub === 'honbu' && <HqCashLedgerPage book="honbu" />}
    </div>
  );
};

export default CashbooksPage;
